import { Pipe, PipeTransform } from '@angular/core';
import { RoleType } from '../../core/services/role.service';

@Pipe({
  name: 'roleTransform',
  standalone: true,
})
export class RoleTransformPipe implements PipeTransform {
  transform(value: RoleType | string): string {
    if (value === RoleType.Employee) {
      return 'Contractor';
    }

    // Para otros roles, devolver el valor original
    if (typeof value === 'string') {
      return value;
    }

    // Si es un valor de RoleType, devolver el nombre del enum
    return value as string;
  }
}
